import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5ad454c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-3" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = {
  key: 0,
  class: "card-action float-end"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cog me-2" }),
  /*#__PURE__*/_createTextVNode("จัดการข้อมูล ")
], -1))
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-file-pdf me-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-file-excel me-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-list-alt me-2" }, null, -1))
const _hoisted_9 = { class: "card-body pt-0" }
const _hoisted_10 = {
  key: 1,
  class: "list-group list-group-flush"
}
const _hoisted_11 = { class: "list-group-item p-0" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "list-group list-group-flush" }
const _hoisted_15 = { class: "list-group-item" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "โครงการที่ดำเนินการ:", -1))
const _hoisted_18 = { class: "col text-end" }
const _hoisted_19 = { class: "list-group-item" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "โครงการที่ยกเลิก:", -1))
const _hoisted_22 = { class: "col text-end" }
const _hoisted_23 = { class: "list-group-item" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "โครงการทั้งหมด:", -1))
const _hoisted_26 = { class: "col text-end" }
const _hoisted_27 = { class: "list-group-item p-0" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md" }
const _hoisted_30 = { class: "list-group list-group-flush" }
const _hoisted_31 = { class: "list-group-item" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบกลาง/เหลือจ่ายที่ได้รับ:", -1))
const _hoisted_34 = { class: "col text-end" }
const _hoisted_35 = { class: "list-group-item" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบที่ใช้จริง:", -1))
const _hoisted_38 = { class: "col text-end" }
const _hoisted_39 = { class: "list-group-item" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบที่ยังไม่นำมาคำนวณ:", -1))
const _hoisted_42 = { class: "col text-end" }
const _hoisted_43 = { class: "list-group-item" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบยกเลิก/ส่วนต่าง/ส่งคืน:", -1))
const _hoisted_46 = { class: "col text-end" }
const _hoisted_47 = { class: "col-md" }
const _hoisted_48 = { class: "list-group list-group-flush" }
const _hoisted_49 = { class: "list-group-item" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบที่ต้องเบิกจ่าย:", -1))
const _hoisted_52 = { class: "col text-end" }
const _hoisted_53 = { class: "list-group-item" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบที่เบิกจ่ายไปแล้ว:", -1))
const _hoisted_56 = { class: "col text-end" }
const _hoisted_57 = { class: "list-group-item" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบที่ส่งคืน:", -1))
const _hoisted_60 = { class: "col text-end" }
const _hoisted_61 = { class: "list-group-item" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "งบที่ยังไม่ได้เบิกจ่าย:", -1))
const _hoisted_64 = { class: "col text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isFile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: "dropdown-item",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pdfClick && _ctx.pdfClick(...args)))
                }, [
                  _hoisted_6,
                  _createTextVNode("เอกสาร PDF ")
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: "dropdown-item",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.excelClick && _ctx.excelClick(...args)))
                }, [
                  _hoisted_7,
                  _createTextVNode("เอกสาร EXCEL ")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_8,
      _createTextVNode("ผลการดำเนินการโครงการใน" + _toDisplayString(_ctx.fiscalYear?.name) + " ของ" + _toDisplayString(_ctx.province?.name !== 'กรุงเทพมหานคร' ? 'จังหวัด': '') + _toDisplayString(_ctx.province?.name), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("ul", _hoisted_10, [
            _createElementVNode("li", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("ul", _hoisted_14, [
                    _createElementVNode("li", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, _toDisplayString(Number(_ctx.summary?.projectCount).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 })) + " โครงการ", 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("div", _hoisted_22, _toDisplayString(Number(_ctx.summary?.cancelProjectCount).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 })) + " โครงการ", 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("div", _hoisted_26, _toDisplayString(Number(_ctx.summary?.totalProjectCount).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 })) + " โครงการ", 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("li", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("ul", _hoisted_30, [
                    _createElementVNode("li", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("div", _hoisted_34, _toDisplayString(Number(_ctx.summary?.totalBudget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท", 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("div", _hoisted_38, _toDisplayString(Number(_ctx.summary?.totalRealBudget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท", 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _hoisted_41,
                        _createElementVNode("div", _hoisted_42, _toDisplayString(Number(_ctx.summary?.totalUncalBudget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท", 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("div", _hoisted_46, _toDisplayString(Number(_ctx.summary?.totalResidual).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท", 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("ul", _hoisted_48, [
                    _createElementVNode("li", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _hoisted_51,
                        _createElementVNode("div", _hoisted_52, _toDisplayString(Number(_ctx.summary?.totalRealBudget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท", 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _createElementVNode("div", _hoisted_56, _toDisplayString(Number(_ctx.summary?.totalSpent).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท", 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _createElementVNode("div", _hoisted_60, _toDisplayString(Number(_ctx.summary?.totalReturnBudget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท", 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _hoisted_63,
                        _createElementVNode("div", _hoisted_64, _toDisplayString(Number(_ctx.summary?.totalRealBudget - _ctx.summary?.totalSpent).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท", 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
    ])
  ]))
}